<template>
  <page :load="doInit">
    <v-container fluid grid-list-md>
      <v-layout row wrap>
        <v-flex xs12>
          <form data-vv-scope="matchForm">
            <v-expansion-panels>
              <v-expansion-panel>
                <v-expansion-panel-header>
                  <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-card>
                    <v-card-text>
                      <v-container fluid grid-list-md>
                        <v-layout row wrap>
                          <v-flex md4 xs12>
                            <v-text-field
                              v-model="filter.glAcctNoBranch"
                              :label="label.glAcctNoBranch"
                              :error-messages="errors.collect('glAcctNoBranch')"
                              data-vv-name="glAcctNoBranch"
                              :data-vv-as="label.glAcctNoBranch"
                              v-validate="'entry|max:4'"
                            >
                              <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                                <v-icon color="info" @click="showBranchHelpList = true" v-text="'mdi-magnify'"></v-icon>
                              </v-slide-x-reverse-transition>
                            </v-text-field>
                          </v-flex>
                          <v-flex md4 xs12>
                            <v-text-field
                              v-model="filter.glAcctNo"
                              :label="label.glAcctNo"
                              :error-messages="errors.collect('filter.glAcctNo')"
                              data-vv-name="filter.glAcctNo"
                              :data-vv-as="label.glAcctNo"
                              v-validate="'entry|max:16'"
                            >
                              <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                                <v-icon color="info" @click="showGlAcctNoHelpList = true" v-text="'mdi-magnify'"></v-icon>
                              </v-slide-x-reverse-transition>
                            </v-text-field>
                          </v-flex>
                          <v-flex md4 xs12>
                            <v-text-field
                              v-model="filter.glAcctNoFund"
                              :label="label.glAcctNoFund"
                              :error-messages="errors.collect('filter.glAcctNoFund')"
                              data-vv-name="filter.glAcctNoFund"
                              :data-vv-as="label.glAcctNoFund"
                              v-validate="'entry|max:4'"
                            >
                              <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                                <v-icon color="info" @click="showFundHelpList = true" v-text="'mdi-magnify'"></v-icon>
                              </v-slide-x-reverse-transition>
                            </v-text-field>
                          </v-flex>
                          <v-flex md4 xs12>
                            <v-text-field
                              v-model="filter.glAcctNoSuffix"
                              :label="label.glAcctNoSuffix"
                              :error-messages="errors.collect('filter.glAcctNoSuffix')"
                              data-vv-name="filter.glAcctNoSuffix"
                              :data-vv-as="label.glAcctNoSuffix"
                              v-validate="'entry|max:4'"
                            >
                              <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                                <v-icon color="info" @click="showAcctSufHelpList = true" v-text="'mdi-magnify'"></v-icon>
                              </v-slide-x-reverse-transition>
                            </v-text-field>
                          </v-flex>
                          <v-flex md4 xs12>
                            <v-text-field
                              v-model="filter.jrnlNo"
                              :label="label.jrnlNo"
                              :error-messages="errors.collect('filter.jrnlNo')"
                              data-vv-name="filter.jrnlNo"
                              :data-vv-as="label.jrnlNo"
                              v-validate="'entry|numeric|mask_min_value:1'"
                            >
                            </v-text-field>
                          </v-flex>
                          <v-flex md4 xs12>
                            <v-text-field
                              v-model="filter.curr"
                              :label="label.curr"
                              :error-messages="errors.collect('filter.curr')"
                              data-vv-name="filter.curr"
                              :data-vv-as="label.curr"
                            >
                              <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                                <v-icon color="info" @click="showCurrencyHelpList = true" v-text="'mdi-magnify'"></v-icon>
                              </v-slide-x-reverse-transition>
                            </v-text-field>
                          </v-flex>
                          <v-flex md4 xs12>
                            <v-autocomplete
                              :items="statusList"
                              v-model="filter.status"
                              :label="label.status"
                              item-text="label"
                              item-value="value"
                              :error-messages="errors.collect('filter.status')"
                              data-vv-name="filter.status"
                              :data-vv-as="label.status"
                              clearable
                            ></v-autocomplete>
                          </v-flex>
                          <v-flex md4 xs12>
                            <cal-picker
                              v-model="filter.date"
                              :label="label.date"
                              :data-vv-as="label.date"
                              data-vv-name="filter.date"
                              :error-messages="errors.collect('filter.date')"
                              v-validate="dateValidation"
                            ></cal-picker>
                          </v-flex>
                          <v-flex md4 xs12>
                            <v-text-field
                              v-model="filter.adjAmount"
                              :label="label.adjAmount"
                              :error-messages="errors.collect('filter.adjAmount')"
                              data-vv-name="filter.adjAmount"
                              :data-vv-as="label.adjAmount"
                              v-num-mask="{ negative: false, intScale: 18, decScale: 2 }"
                            ></v-text-field>
                          </v-flex>
                          <v-flex md4 xs12>
                            <v-text-field
                              v-model="filter.reason"
                              :label="label.reason"
                              :error-messages="errors.collect('filter.reason')"
                              data-vv-name="filter.reason"
                              :data-vv-as="label.reason"
                            ></v-text-field>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-card-text>
                    <v-layout row wrap>
                      <v-spacer></v-spacer>
                      <v-card-actions>
                        <v-btn color="red darken-1" text @click.native="doClearFilters">Clear Filters</v-btn>
                        <v-btn color="primary" text type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
                      </v-card-actions>
                    </v-layout>
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </form>
        </v-flex>
      </v-layout>
      <v-spacer class="mt-2"></v-spacer>
      <v-layout row wrap>
        <v-flex xs12>
          <v-card>
            <v-layout row wrap>
              <v-flex class="text-right">
                <v-btn class="mr-2" color="primary" @click.native="doPrint">
                  <span>Filter Records</span>
                  <v-icon right dark>mdi-printer</v-icon>
                </v-btn>
                <v-btn class="mr-2" color="primary" @click.native="doNew">
                  <span>New Adjustment</span>
                  <v-icon right dark>mdi-plus</v-icon>
                </v-btn>
              </v-flex>
              <v-flex xs12>
                <v-card>
                  <v-data-table
                    v-bind:headers="listJournalHeaders"
                    v-bind:items="items"
                    :server-items-length="totalItems"
                    :footer-props="{'items-per-page-options': itemsPerPage }"
                    v-bind:options.sync="pagination"
                    item-key="key"
                    :loading="loading"
                    :no-data-text="noDataText"
                  >
                    <template v-slot:item="row"
                      ><tr>
                        <td v-for="column in selectedJournalColumns" :key="column">{{ row.item[column] }}</td>
                        <td class="table-action-header" v-if="row.item.status === 'IP' || row.item.status === 'WA'">
                          <table-action :rowData="row" review @review="doReview(row.item)" query @query="doQuery(row.item)"></table-action>
                        </td>
                        <td class="table-action-header" v-else>
                          <table-action :rowData="row" query @query="doQuery(row.item)"></table-action>
                        </td></tr
                    ></template>
                  </v-data-table>
                </v-card>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
      <v-dialog v-model="showErrorDialog" width="800px">
        <v-card>
          <v-card-title primary-title>
            <div>
              <div class="headline">System Information</div>
              <span class="grey--text">An error occurred when printing.</span>
            </div>
          </v-card-title>
          <v-card-text>
            <div v-if="messages.length > 0" class="pb-3">
              <v-subheader>Error Details:</v-subheader>
              <ul class="showErrorMsgs">
                <li v-for="(error, index) in messages" :key="index">
                  {{ error.message }}
                </li>
              </ul>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" text @click.native="showErrorDialog = false">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="showGlAcctNoHelpList" width="1280px">
        <gl-acct-no-help-list2 @close="showGlAcctNoHelpList = false" @assign-gl-acct-no="assignGlAcctNo"></gl-acct-no-help-list2>
      </v-dialog>

      <v-dialog v-model="showBranchHelpList" width="1280px">
        <branch-help-list @close="showBranchHelpList = false" @assign-branch="assignBranch"></branch-help-list>
      </v-dialog>

      <v-dialog v-model="showFundHelpList" width="1280px">
        <fund-help-list @close="showFundHelpList = false" @assign-fund="assignFund"></fund-help-list>
      </v-dialog>

      <v-dialog v-model="showAcctSufHelpList" width="1280px">
        <acct-suf-help-list @close="showAcctSufHelpList = false" @assign-acct-suf="assignAcctSuf"></acct-suf-help-list>
      </v-dialog>

      <v-dialog v-model="showCurrencyHelpList" width="1280px">
        <cr-currency-help-list @close="showCurrencyHelpList = false" @assign-currency="assignCurr"></cr-currency-help-list>
      </v-dialog>
    </v-container>
  </page>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { journalAjaxMixin } from '@/mixins/accounting/journal/journalAjaxMixin'
import { journalFilterMixin } from '@/mixins/accounting/journal/journalFilterMixin'
import { journalListMixin } from '@/mixins/accounting/journal/journalListMixin'
import GlAcctNoHelpList2 from '@/components/core/common/dialog/GlAcctNoHelpList2'
import BranchHelpList from '@/components/core/common/dialog/BranchHelpList'
import FundHelpList from '@/components/core/common/dialog/FundHelpList'
import AcctSufHelpList from '@/components/core/common/dialog/AcctSufHelpList'
import CrCurrencyHelpList from '@/components/core/common/dialog/CrCurrencyHelpList'
import { removeTime } from '@/utils/date'
import isAfter from 'date-fns/isAfter'
import { parseISO } from 'date-fns'

export default {
  data() {
    return {
      branches: [],
      showGlAcctNoHelpList: false,
      showBranchHelpList: false,
      showFundHelpList: false,
      showAcctSufHelpList: false,
      showCurrencyHelpList: false,
      showErrorDialog: false,
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  methods: {
    async doInit() {
      await Promise.all([this.$store.dispatch('journalInit')])
      await Promise.all([this.$store.dispatch('reportsInit')])
      await Promise.all([this.$store.dispatch('acctReportsInit')])
      this.getAcctJournalMenuLink()
      this.performSearch()
    },
    doNew() {
      const commit = {
        tranMode: 'New',
        jrnlNo: null,
        status: null
      }
      sessionStorage.setItem('jrnl', JSON.stringify(commit))
      this.$store.commit('JOURNAL_COMMIT_KEY', commit)
      this.$router.push({ name: 'journalDetails' }).catch(() => {})
    },
    doReview(data) {
      const commit = {
        tranMode: 'Review',
        jrnlNo: data.jrnlNo,
        status: data.status,
        statusDesc: data.statusDesc
      }
      sessionStorage.setItem('jrnl', JSON.stringify(commit))
      this.$store.commit('JOURNAL_COMMIT_KEY', commit)
      this.$router.push({ name: 'journalDetails' }).catch(() => {})
    },
    doQuery(data) {
      const commit = {
        tranMode: 'Query',
        jrnlNo: data.jrnlNo,
        status: data.status,
        statusDesc: data.statusDesc
      }
      sessionStorage.setItem('jrnl', JSON.stringify(commit))
      this.$store.commit('JOURNAL_COMMIT_KEY', commit)
      this.$router.push({ name: 'journalDetails' }).catch(() => {})
    },
    async doPrint() {
      if (
        this.filter.glAcctNoBranch !== '' ||
        this.filter.glAcctNo !== '' ||
        this.filter.glAcctNoFund !== '' ||
        this.filter.glAcctNoSuffix !== '' ||
        this.filter.jrnlNo !== '' ||
        this.filter.curr !== '' ||
        this.filter.status !== '' ||
        this.filter.date !== '' ||
        this.filter.adjAmount !== '' ||
        this.filter.reason !== ''
      ) {
        this.doExportAcctJournlReport()
      } else {
        const errMsg = {
          messages: [{ message: 'Must selected Or filtered records', type: 'ERROR' }]
        }
        this.message(errMsg)
        this.fieldMessage(errMsg)
      }
    },
    assignGlAcctNo(glAcctNo) {
      this.filter.glAcctNo = glAcctNo
      this.showGlAcctNoHelpList = false
    },
    assignBranch(branch) {
      this.filter.glAcctNoBranch = branch
      this.showBranchHelpList = false
    },
    assignFund(fund) {
      this.filter.glAcctNoFund = fund
      this.showFundHelpList = false
    },
    assignAcctSuf(acctNoSfx) {
      this.filter.glAcctNoSuffix = acctNoSfx
      this.showAcctSufHelpList = false
    },
    assignCurr(curr) {
      this.filter.curr = curr
      this.showCurrencyHelpList = false
    }
  },
  watch: {
    displayErrorDialog: {
      handler: function (messages) {
        if (messages && messages.length > 0) {
          this.showErrorDialog = true
        }
      },
      deep: true
    }
  },
  computed: {
    dateValidation() {
      var minDate = '2019-01-01'

      if (this.filter.date !== '' && this.filter.date !== null) {
        return 'entry|valDate:' + parseISO(minDate)
      } else {
        return ''
      }
    },
    displayErrorDialog() {
      return this.messages
    }
  },
  created() {
    this.$validator.extend('valDate', {
      getMessage(field, args) {
        return 'Date must be equal or greater than 01/01/2019'
      },
      validate(value, args) {
        if (args === void 0) args = []
        var expDate = args[0]
        if (expDate) {
          return !isAfter(removeTime(expDate), removeTime(value))
        }
      }
    })
  },
  mixins: [MessageMixin, journalAjaxMixin, journalFilterMixin, journalListMixin],
  components: {
    GlAcctNoHelpList2,
    BranchHelpList,
    FundHelpList,
    AcctSufHelpList,
    CrCurrencyHelpList
  }
}
</script>
